import { Card } from 'antd';
import React, { useState } from 'react';
import './Cards.scss';
const { Meta, Grid } = Card;

const Cards = (props) => {
  const { title, icon, count, content, selectedCard, borderStyle, headStyle, data } = props;
  const contentDetails = () => {
    let tempData = content;
    if (content === "Received" || content === "Resolved") {
      tempData = tempData + ` by authority`;
    }
    else if (content === "Escalated") {
      tempData = tempData + ` to higher official`;
    }
    else if (content === "In_Progress") {
      tempData = tempData?.replace('_', " ");
    }
    return tempData;
  }
  return (
    <>
      <Card
        title={title}
        headStyle={{
          backgroundColor: headStyle?.backgroundColor,
          fontFamily: "Roboto-Regular",
          fontSize: 18,
          color: "#FFFFFF"
        }}
        style={{
          width: content !== "Escalated" ? 300 : 320,
          marginTop: 16,
          borderColor: borderStyle?.borderColor,
          backgroundColor: borderStyle?.backgroundColor,
          borderRadius: 6,
          cursor: borderStyle?.cursor,
        }}
      >
        {content &&
          <Meta
            className='content'
            avatar={icon}
            title={count}
            description={contentDetails()}
          />
        }
        {data?.map(item => {
          return (
            <Grid
              style={{ width: '50%' }}
              hoverable={false}
            >
              <div className='gridHeader'>
                {item?.label === "Received" &&
                  <>Received by authority</>
                }
                {item?.label === "Resolved" &&
                  <>Resolved by authority</>
                }
                {item?.label === "Escalated" &&
                  <>Escalated to higher official</>
                }
                {item?.label === "In Progress" &&
                  <>
                    <div>{`${item?.label}`}</div>
                    <div style={{ marginBottom: 26 }} />
                  </>
                }
              </div>
              <div className='gridContent'>{item?.count}</div>
            </Grid>
          )
        }

        )
        }
      </Card>

    </>
  );
};

export default Cards;